var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{attrs:{"color":"red"}},[_c('h4',[_vm._v(_vm._s(_vm.data.name))])]),_c('v-divider'),_c('v-card-text')],1)}
var staticRenderFns = []

export { render, staticRenderFns }